import { DropdownOptions } from 'ia-react-core';
import { useLocation } from 'react-router';

export default function useDropdownDefaultValue(name: string, options: DropdownOptions<string>): string {
  const { search } = useLocation();
  const defaultKey = new URLSearchParams(search).get(name);
  const defaultValue = options.filter((x) => x.value === defaultKey)[0]?.value;

  return defaultValue;
}
